import React from 'react';
import { connect } from 'react-redux';
import { ButtonLink } from '@fttb/common/components';
import classNames from 'classnames/bind';
import PropTypes from 'prop-types';
import { onTariffButtonClickWithAnalytics } from "../../../../store/blocks/tariffs/actions";
import { getPresetTariffUrl } from "../../../../store/blocks/tariffs/tariffButtonSelectors";
import { getIsMyTariff, getTariffButtonText, selectHidePointerEventFlag, selectIsLoadingTariffButtonFlag } from "../../../../store/blocks/tariffs/tariffSelectors";
import styles from "./styles.pcss";
var cn = classNames.bind(styles);
export var _TariffButton = function _TariffButton(_ref) {
  var children = _ref.children,
    className = _ref.className,
    href = _ref.href,
    isHidePointerEvent = _ref.isHidePointerEvent,
    isLoading = _ref.isLoading,
    isMyTariff = _ref.isMyTariff,
    isPopular = _ref.isPopular,
    _onClick = _ref.onClick;
  return /*#__PURE__*/React.createElement(ButtonLink, {
    className: cn('button', className, {
      'hide-pointer-event': isHidePointerEvent
    }),
    fullWidth: true,
    href: href,
    isLoading: isLoading,
    onClick: function onClick(e) {
      return _onClick(e, isPopular);
    },
    size: "m",
    variant: isMyTariff ? 'tertiary' : 'main',
    "data-t-id": "components-TariffButton"
  }, children);
};
_TariffButton.propTypes = process.env.NODE_ENV !== "production" ? {
  children: PropTypes.node,
  className: PropTypes.string,
  href: PropTypes.string,
  isMyTariff: PropTypes.bool,
  isPopular: PropTypes.bool,
  onClick: PropTypes.func
} : {};
var mapStateToProps = function mapStateToProps(state) {
  return {
    children: getTariffButtonText(state),
    href: getPresetTariffUrl(state),
    isHidePointerEvent: selectHidePointerEventFlag(state),
    isLoading: selectIsLoadingTariffButtonFlag(state),
    isMyTariff: getIsMyTariff(state)
  };
};
var mapDispatchToProps = {
  onClick: onTariffButtonClickWithAnalytics
};
export var TariffButton = connect(mapStateToProps, mapDispatchToProps)(_TariffButton);